import React, { useState, useEffect } from "react";
import "../styles/navbar.css";
import logo from "../assets/shanna-logo1.jpg";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { auth, db } from "../firebase";
import { useAuthState } from "react-firebase-hooks/auth";
import { doc, getDoc } from "firebase/firestore";

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const [isAdmin, setIsAdmin] = useState(false);

  const location = useLocation();
  const navigate = useNavigate();

  // Auth hook
  const [user] = useAuthState(auth);

  // Detectar si el usuario es admin
  useEffect(() => {
    const checkAdmin = async () => {
      if (!user) {
        setIsAdmin(false);
        return;
      }
      const ref = doc(db, "admins", user.uid);
      const snap = await getDoc(ref);
      setIsAdmin(snap.exists());
    };

    checkAdmin();
  }, [user]);

  // Cerrar menú si cambia el tamaño de la ventana
  useEffect(() => {
    const onResize = () => {
      if (window.innerWidth > 768) setOpen(false);
    };
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  // Cerrar automáticamente cuando cambia de ruta
  useEffect(() => {
    setOpen(false);
  }, [location]);

  // Logout
  const logout = async () => {
    await auth.signOut();
    navigate("/");
  };

  return (
    <header className="nav-wrapper">
      <div className="nav-inner">
        {/* LOGO */}
        <Link to="/" className="brand" onClick={() => setOpen(false)}>
          <img src={logo} alt="Shanna logo" className="brand-logo" />
          <span className="brand-text">Shanna</span>
        </Link>

        {/* Botón hamburguesa */}
        <button
          aria-label={open ? "Cerrar menú" : "Abrir menú"}
          className={`nav-toggle ${open ? "open" : ""}`}
          onClick={() => setOpen((s) => !s)}
        >
          <svg className="icon-hamb" viewBox="0 0 24 24" width="24" height="24">
            {open ? (
              <path
                fill="currentColor"
                d="M18.3 5.71a1 1 0 0 0-1.41-1.41L12 9.59 7.11 4.7A1 1 0 0 0 5.7 6.11L10.59 11 5.7 15.89a1 1 0 1 0 1.41 1.41L12 12.41l4.89 4.89a1 1 0 0 0 1.41-1.41L13.41 11l4.89-4.89z"
              />
            ) : (
              <path
                fill="currentColor"
                d="M3 6h18a1 1 0 0 0 0-2H3a1 1 0 0 0 0 2zm18 5H3a1 1 0 0 0 0 2h18a1 1 0 0 0 0-2zm0 7H3a1 1 0 0 0 0 2h18a1 1 0 0 0 0-2z"
              />
            )}
          </svg>
        </button>

        {/* Enlaces */}
        <nav className={`nav-links ${open ? "show" : ""}`}>
          <Link to="/" onClick={() => setOpen(false)}>Inicio</Link>
          <Link to="/about" onClick={() => setOpen(false)}>Sobre Mi</Link>
          <Link to="/services" onClick={() => setOpen(false)}>Servicios</Link>
          <Link to="/turnos" onClick={() => setOpen(false)}>Turnos</Link>
          <Link to="/contact" onClick={() => setOpen(false)}>Contacto</Link>

          {/* 🔐 VISIBLE SOLO PARA ADMIN */}
          {isAdmin && (
            <>
              <Link
                to="/admin/turnos"
                onClick={() => setOpen(false)}
              >
                Panel de turnos
              </Link>

              <Link
                to="/admin/dashboard"
                onClick={() => setOpen(false)}
              >
                Dashboard
              </Link>
            </>
          )}

          {/* 🔓 Login / Logout */}
          {!user && (
            <Link to="/admin/login" onClick={() => setOpen(false)}>
              Iniciar Sesión (Admin)
            </Link>
          )}

          {user && (
            <button className="logout-btn" onClick={logout}>
              Cerrar sesión
            </button>
          )}
        </nav>
      </div>
    </header>
  );
}
